import './App.css';
import {Navigate, Route, Routes} from "react-router-dom";
import Navbar from "./components/Navbar";
import {routesMap} from "./routes/routesMap";
import {Box} from "@mui/material";
import Footer from "./components/Footer";
import {useLang} from "./hooks/useLang";
import {useSEO} from "./hooks/useSEO";

function App() {
    const lang = useLang();
    useSEO({ lang });
    return (
        <Box sx={{ display: "flex", flexDirection: "column", maxWidth: "100vw", minHeight: "100vh", maxHeight: {md: "100vh"} }}>
            <Navbar routesMap={routesMap} lang={lang}/>
            <Box
                p={{ xs:2, md: 4}}
                sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    width: "100%",
                    height: "100%"
                }}
            >
                <Routes>
                    {Object.entries(routesMap).map(([key, def]) =>
                        Object.entries(def.path).map(([lang, path]) => (
                            <Route
                                key={`${key}-${lang}`}
                                path={path}
                                element={<def.component lang={lang}/>}
                            />
                        ))
                    )}

                    {/* Redirect root alla lingua di default (es. IT) */}
                    <Route path="/" element={<Navigate to="/it/home" replace/>}/>

                    {/* Fallback 404 */}
                    <Route path="*" element={<h1>404 - Not Found</h1>}/>
                </Routes>
            </Box>
            <Footer/>
        </Box>
    );
}

export default App;